import { Inject, Injectable, DOCUMENT } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';
import { lastValueFrom } from 'rxjs';
import { sharedConfig } from 'src/environments/shared-config';

@Injectable({
    providedIn: 'root'
})
export class TranslatorService {
    private defaultLanguage = environment.defaultLanguage;
    private currentLangauge = environment.defaultLanguage;
    public isRightToLeft: boolean = false;
    defaultActiveLang = "en";

    constructor(public translate: TranslateService,
        @Inject(DOCUMENT) private document: Document) {
        if (!translate.getFallbackLang()) translate.setFallbackLang(this.defaultLanguage);
        this.setDefaultLanguage(this.currentLangauge);
    }

    setDefaultLanguage(lang: string = ''): string {
        const lanToUse = lang || this.translate.getFallbackLang();
        const selectedLanguage = sharedConfig.availablelanguages.find(obj => obj.code === lanToUse);
        if (lanToUse && selectedLanguage) {
            this.currentLangauge = lanToUse;
            this.document.documentElement.lang = lanToUse;
            this.document.documentElement.dir = selectedLanguage.dir;
            const elem = this.document.getElementsByClassName('section-container')[0] as HTMLElement;
            if (elem) {
                elem.dir = selectedLanguage.dir;
            }
            this.isRightToLeft = selectedLanguage.dir === 'rtl';
            return lanToUse;
        }
        return this.defaultActiveLang;
    }

    async useLanguage(lang: string = '', fireEvents: boolean = true): Promise<void> {
        const lanToUse = this.setDefaultLanguage(lang);
        if (fireEvents) {
            await lastValueFrom(this.translate.use(lanToUse));
        }
    }

    getAvailableLanguages() {
        return sharedConfig.availablelanguages;
    }

    getCurrentLanguage(): string {
        return this.currentLangauge;
    }

    getIsRTL(): boolean {
        return this.isRightToLeft;
    }

    async refreshRTL() {
        if (this.isRightToLeft) {
            const rememberLang = this.currentLangauge;
            await this.useLanguage('en', false);
            await this.useLanguage(rememberLang, false);
        }
    }

    translateText(key: string | string[], interpolateParams?: object): string {
        return this.translate.instant(key, interpolateParams);
    }
}